import { createContext } from 'react';
import { ExternalData } from '../../@types/external-api';
import { SystemHealthEnvironmentStatus, SystemHealthStatus } from './systems-health-model';

export interface SystemsHealthCtxType {
  systemsHealth: {
    self: ExternalData<SystemHealthStatus>;
    amwayProfile: ExternalData<SystemHealthStatus>;
    uplines: ExternalData<SystemHealthStatus>;
    docgen: ExternalData<SystemHealthStatus>;
    orderApi: ExternalData<SystemHealthStatus>;
    itemApi: ExternalData<SystemHealthStatus>;
    volumeApi: ExternalData<SystemHealthStatus>;
    exponea: ExternalData<SystemHealthStatus>;
    publisherApi: ExternalData<SystemHealthStatus>;
    ngcOrderDetailsApi: ExternalData<SystemHealthEnvironmentStatus[]>;
    ngcReturnDetailsApi: ExternalData<SystemHealthEnvironmentStatus[]>;
    ngcAccountDetailsApi: ExternalData<SystemHealthEnvironmentStatus[]>;
    ngcAccountMappingsApi: ExternalData<SystemHealthEnvironmentStatus[]>;
    ngcAccountsByProfileIdApi: ExternalData<SystemHealthEnvironmentStatus[]>;
    ngcPaymentsApi: ExternalData<SystemHealthEnvironmentStatus[]>;
    ngcProfileByPartyIdApi: ExternalData<SystemHealthEnvironmentStatus[]>;
    ngcProfileApi: ExternalData<SystemHealthEnvironmentStatus[]>;
    ngcUserApi: ExternalData<SystemHealthEnvironmentStatus[]>;
    ngcAccountEmailsApi: ExternalData<SystemHealthEnvironmentStatus[]>;
    ngcAccountPhonesApi: ExternalData<SystemHealthEnvironmentStatus[]>;
    ngcAnonymousDeliveryTrackingApi: ExternalData<SystemHealthEnvironmentStatus[]>;
  };
  fetchSystemsHealth: VoidFunction;
}

const SystemsHealthContext = createContext<SystemsHealthCtxType>(null as any);

export default SystemsHealthContext;
